import { UserAttribute } from './userattribute';

export class UserAttributeWrapper {
    public userId: number = 0;
    public jobPostingId: number = 0;
    public userAttributeList: UserAttribute[] = [];
    public referralCode: string = '';
    public userattributeFileMap: any;

}

